// ABOUTME: The address of a picture the API hands out as a signed path — this client's image host in front of it.
// ABOUTME: The host stays the client's own: one picture is served from several domains, and the signature covers the path alone.
import config from "@/config"

export const imageUrl = (signedPath: string): string => `${config.AVATAR_URL}${signedPath}`
